import { Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavbarAll from "../Navbar/NavbarAll";
import "./AllServices.css"; 

const services = [
  {
    title: "Emergency Relief",
    image: "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/12Emergency.jpg",
    description: "Providing rapid relief in times of disaster, floods, and emergencies.",
    link: "/disaster-relief",
  },
  {
    title: "Health Support",
    image: "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/3Health%20Support.jpg?updatedAt=1760377725079",
    description: "Khadija-tul-Kubra Welfare Trust is committed to providing accessible and quality healthcare to underserved communities",
    link: "/health-support",
  },
  {
    title: "Self-Sustainable Projects",
    image: "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/7Self%20Sustainable%20Projects.jpg",
    description: "Helping individuals become self-reliant through rickshaws, goats, stalls, and vocational training.",
    link: "/self-sufficiency-projects",
  },
  {
    title: "Quranic Institutes Network",
    image: "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/9Quranic%20Institutes%20Network.jpg",
    description: "Over 30 Quranic schools established in underprivileged areas across Pakistan.",
    link: "/quranic-institutes-network",
  },
  {
    title: "Food Distribution",
    image: "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/5Food%20Supply.jpg?updatedAt=1760378090973",
    description: "More than 50,000 families supported with rations, cooked meals, and hospital food programs.",
    link: "/food-supply",
  },
  {
    title: "Water Supply",
    image: "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/4water.jpg?updatedAt=1760377958278",
    description: "200+ clean water projects including solar plants, RO systems, and hand pumps.",
    link: "/water-supply",
  },
  {
    title: "Orphans Support",
    image: "https://ik.imagekit.io/nfs93gxmp/Orphanage/2Orphans%20Support.jpg?updatedAt=1760377266581",
    description: "Dar-e-Khadija provides shelter, education, and care for orphan children.",
    link: "/orphans-support",
  },
  {
    title: "Education Services",
    image: "https://ik.imagekit.io/nfs93gxmp/Education/1Edu.jpg?updatedAt=1760376973722",
    description: "Providing Islamic and modern education to 300+ students in Karachi and beyond.",
    link: "/education",
  },
  {
    title: "Quilts & Clothing Distribution",
    image: "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/6quilt%20&%20cloth.jpg?updatedAt=1760378302579",
    description: "Distributing Eid clothes, shoes, and seasonal clothing to 10,000+ beneficiaries.",
    link: "/quilts-clothing",
  },
  {
    title: "Protection of Holy Papers",
    image: "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/11Protection%20Of%20Holy%20Papers.jpg",
    description: "50+ collection boxes installed to safely dispose of Quranic manuscripts with dignity.",
    link: "/holy-papers-protection",
  },
  {
    title: "Marriage Assistance",
    image: "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/8Marriage%20Support.jpg",
    description: "Supporting underprivileged families by providing dowry, dresses, and wedding expenses.",
    link: "/marriage-assistance",
  },
   {
    title: "Construction and Management of Mosques",
    image: "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/10Construction%20of%20Mosques.jpg?updatedAt=1760378629448",
    description: "Khadija-tul-Kubra Welfare Trust is committed to the construction and management of mosques, particularly in remote, underprivileged, and densely populated areas",
    link: "/construction-and-management-of-mosques",
  },
];


const AllServices = () => {
  const navigate = useNavigate();

  const handleNavigate = (link) => {
    window.scrollTo(0, 0);
    navigate(link);
  };

  return (
    <>
      <NavbarAll />
      <Box className="services-container">
        <Typography variant="h4" className="services-title">
          All Services
        </Typography>

        <Box className="services-grid">
          {services.map((service, index) => (
            <Box key={index} className="service-card">
              <img src={service.image} alt={service.title} className="service-image" />
              <Box className="service-content">
                <Typography variant="h6" className="service-title">
                  {service.title}
                </Typography>
                <Typography variant="body2" className="service-description">
                  {service.description}
                </Typography>
                <button className="service-button" onClick={() => handleNavigate(service.link)}>
                  Read More
                </button>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default AllServices;
